import { ConcreteEncodable } from "./ConcreteEncodable";

import { ClientContactUpdateRequestImplEncoder } from "../../encoder/ClientContactUpdateRequestImplEncoder";

import * as CubiqTS from "../../index";
import { ClientContactUpdateRequest } from "../ClientContactUpdateRequest";

export class ClientContactUpdateRequestImpl
  extends ConcreteEncodable
  implements ClientContactUpdateRequest
{
  public static enType: string = "com.bcdfx.model.event.ClientContactUpdateRequestImpl";

  /*FID=1*/
  public clientCode: string;
  /*FID=2*/
  public contactName: string;
  /*FID=3*/
  public desk: string;
  /*FID=4*/
  public mobile: string;
  /*FID=5*/
  public email: string;
  /*FID=6*/
  public isDefault: boolean;
  /*FID=7*/
  public sms: string;
  /*FID=8*/
  public notifyEntry: CubiqTS.NotificationMethod;
  /*FID=9*/
  public notifyExpiry: CubiqTS.NotificationMethod;
  /*FID=10*/
  public notifyFill: CubiqTS.NotificationMethod;
  /*FID=11*/
  public clientContactId: CubiqTS.Long | null = null;
  /*FID=12*/
  public notifyModify: CubiqTS.NotificationMethod;
  /*FID=13*/
  public notifyCancel: CubiqTS.NotificationMethod;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ClientContactUpdateRequestImplEncoder.Instance;
    this.setEncodableType(ClientContactUpdateRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "ClientContactUpdateRequestImpl[" +
      "clientCode=" +
      this.clientCode +
      "contactName=" +
      this.contactName +
      "desk=" +
      this.desk +
      "mobile=" +
      this.mobile +
      "email=" +
      this.email +
      "isDefault=" +
      this.isDefault +
      "sms=" +
      this.sms +
      "notifyEntry=" +
      this.notifyEntry +
      "notifyExpiry=" +
      this.notifyExpiry +
      "notifyFill=" +
      this.notifyFill +
      "clientContactId=" +
      this.clientContactId +
      "notifyModify=" +
      this.notifyModify +
      "notifyCancel=" +
      this.notifyCancel +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
